module.exports = __webpack_public_path__ + "static/media/arlicar1.bc216275.webp";